var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIdBadge = function SvgIdBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.158a.218.218 0 0 1 0-.435M12 4.158a.218.218 0 1 0 0-.435",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.178 5.465h4.357a.871.871 0 0 1 .871.872v14.812a.87.87 0 0 1-.871.871H5.465a.871.871 0 0 1-.871-.871V6.337a.871.871 0 0 1 .871-.872h4.357",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.792 19.842-3.05-1.307v-1.743s.755-.305.755-2.178c.596 0 .823-1.743-.006-1.743a2.293 2.293 0 0 0 .384-1.742c-.428-1.743-4.645-1.743-5.073 0-1.8-.375-.368 1.491-.368 1.742-.855 0-.855 1.743 0 1.743 0 1.873.824 2.178.824 2.178v1.743l-3.05 1.307M14.178 6.772a.436.436 0 0 1-.435.436h-3.486a.436.436 0 0 1-.435-.436V4.158a2.178 2.178 0 0 1 4.356 0v2.614Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgIdBadge;